import { useState, useEffect } from 'react';

const useProjectFilter = (projects) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [uniqueTechnologies, setUniqueTechnologies] = useState([]);

  // Extraer tecnologías únicas de los proyectos
  useEffect(() => {
    const allTechnologies = [];
    projects.forEach(project => {
      project.technologies.forEach(tech => {
        if (!allTechnologies.some(item => item.name === tech.name)) {
          allTechnologies.push(tech);
        }
      });
    });
    setUniqueTechnologies(allTechnologies);
    setFilteredProjects(projects);
  }, [projects]);

  // Filtrar proyectos cuando cambia el filtro activo
  useEffect(() => {
    if (activeFilter === 'all') {
      setFilteredProjects(projects);
    } else {
      const filtered = projects.filter(project => 
        project.technologies.some(tech => tech.name === activeFilter)
      );
      setFilteredProjects(filtered);
    }
  }, [activeFilter, projects]);

  return {
    activeFilter,
    setActiveFilter,
    filteredProjects,
    uniqueTechnologies
  };
};

export default useProjectFilter;